export function StaticConstructable(constructor) {
  constructor.construct();
  return constructor;
}
